import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { receiptsAccessControl } from '../access-control/receiptsAccess.configuration'

const ReceiptsListPage = lazy(() =>
  import(
    /* webpackChunkName: "ReceiptsListPage" */
    '../pages/receipts-list'
  ).then(module => ({ default: module.ReceiptsListPage }))
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const receiptsPartnerScopedRouter = (
  <DomainRoute route="receipts-partner-scoped" accessControl={receiptsAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="receipts-list"
        component={ReceiptsListPage as React.ComponentType<any>}
        accessControl={receiptsAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
